import React, { useState } from "react";
import SeoHead from "../../../../components/SeoHead";
import BulkPaymentHero from "../../services/bulk-payment/BulkPaymentHero";
import WorkSmarter from "../../services/bulk-payment/WorkSmarter";
import WorkPayment from "../../services/bulk-payment/WorkPayment";
import JoinNetwork from "../../services/bulk-payment/JoinNetwork";
import ElectricityModal from "./modal/ElectricityModal";
import img13 from "../../../../assets/img/img13.png";
import svg120 from "../../../../assets/svg/svg120.svg";
import svg121 from "../../../../assets/svg/svg121.svg";
import svg122 from "../../../../assets/svg/svg122.svg";
import svg123 from "../../../../assets/svg/svg123.svg"; 
import svg116 from "../../../../assets/svg/svg116.svg";
import svg108 from "../../../../assets/svg/svg108.svg";
import svg109 from "../../../../assets/svg/svg109.svg";
import svg111 from "../../../../assets/svg/svg111.svg";
import svg112 from "../../../../assets/svg/svg112.svg";
import svg118 from "../../../../assets/svg/svg118.svg";
import svg119 from "../../../../assets/svg/svg119.svg";
import svg98 from "../../../../assets/svg/svg98.svg";

const itemsHero = [
  {
    title: "Enter Meter Details",
    svg: svg98,
    desc: "Provide your meter number and select the amount you want to pay or recharge.",
  },
  {
    title: "Make Secure Payment",
    svg: svg118,
    desc: "Complete your transaction quickly using your preferred payment method.",
  },
  {
    title: "Receive Tokens Instantly",
    svg: svg119, 
    desc: "Get your electricity token immediately and stay connected without interruptions.",
  },
];

const itemsSmarter = [
  {
    title: "Multi-Network Support",
    svg: svg120,
    desc: "Digitized petty cash requests and approvals to remove manual handling and delays.",
  },
  {
    title: "Smarter Budgeting",
    svg: svg121,
    desc: "Monitor spending by department, set limits, and stay within budget effortlessly.",
  },
  {
    title: "Fast, Bulk Distribution",
    svg: svg122,
    desc: "Disburse funds instantly to teams and field agents, keeping operations moving.",
  },
  {
    title: "Controlled Disbursements",
    svg: svg116,
    desc: "Gain complete visibility. Every transaction is tracked, approved, and auditable.",
  },
  {
    title: "Real-Time Tracking",
    svg: svg123,
    desc: "Generate detailed reports in seconds for clear, compliant financial reviews.",
  },
];

const itemsWorkPayment = [
  {
    svg: svg108,
    title: "Fund Your Wallet",
    desc: "Add funds via bank transfer or mobile money.",
  },
  {
    svg: svg109,
    title: "Upload Recipients",
    desc: "Add phone numbers manually or import a list via Excel or CSV.",
  },
  {
    svg: svg111,
    title: "Amounts & Networks",
    desc: "Approved requests are funded instantly via wallet or linked account.",
  },
  {
    svg: svg112,
    title: "Send Instantly",
    desc: "Distribute airtime or data bundles and track delivery in real time.",
  },
];

function ElectricityPage() {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <SeoHead
        title="Electricity Payments"
        description="Buy KPLC tokens or pay your electricity bill instantly. Seamless electricity payments for every home and business with Impala Digital Payments."
        path="/utility/electricity"
      />
      <BulkPaymentHero
        items={itemsHero}
        title="Seamless Electricity Payments for Every Home"
        subtitle="Pay electricity bills or purchase prepaid tokens quickly and securely."
        svg101={img13}
        onCtaClick={() => setOpen(true)}
        ctaLabel="Buy token or pay bill"
      />
      <WorkSmarter
        items={itemsSmarter}
        title="Built to Make Cash Management Effortless"
        subtitle="Go digital, save time, and stay fully in control of your operational expenses."
      />
      <WorkPayment
        items={itemsWorkPayment}
        title="How Bill Payments & Settlements Work"
        subtitle="Process all your supplier and utility payments in four simple steps"
      />
      <JoinNetwork
        title="Join the growing network of organizations using Impala Digital Payments"
        subtitle="Experience the future of business payments with Impala Digital Payments"
      />
      <ElectricityModal isModalOpen={open} handleCancel={() => setOpen(false)} />
    </div>
  );
}

export default ElectricityPage;
